import { IContractReview } from 'global/interfaces/contract';
import { authorizedPost } from './baseApiService';

const coreResource = 'core/Contract';

export async function createRating(review: IContractReview): Promise<boolean> {
  return await authorizedPost<boolean>(`${coreResource}/contract-review`, review);
}
